import { motion, useAnimation } from 'framer-motion'
import SVGJSContainer, {
	pathMove,
	textVariants
} from '../../../utils/SVGJSContainer'
import NumberAnimate from '../../NumberAnimate'

function Promouvoir6() {
	const controls = useAnimation()

	return (
		<SVGJSContainer controls={controls}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="1723"
				height="700.621"
				viewBox="0 0 1723 700.621"
			>
				<g data-name="Groupe 2554" transform="translate(0 -4708.189)">
					<motion.path
						fill="#79b05e"
						d="M1232.295-435.006l.133-.235h65.963l33.522 55.317-33.522 54.283h-65.422l-32.56-54.843z"
						data-name="Tracé 30290"
						stroke="#ebe963"
						transform="translate(-256.354 5202.188)"
						variants={pathMove}
						initial="hidden"
						animate={controls}
					></motion.path>
					<motion.path
						fill="#ebe963"
						stroke="#79b05e"
						d="M424.641 226.569l159.226-281.26h334.922l170.206 281.26-170.206 276H586.611z"
						data-name="Tracé 30289"
						transform="translate(58.634 4931.238)"
						variants={pathMove}
						initial="hidden"
						animate={controls}
					></motion.path>
					<text
						data-name="1142"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="100"
						fontWeight="700"
						letterSpacing="-.05em"
						transform="translate(592.951 5093.435)"
					>
						<tspan x="90" y="0">
							<NumberAnimate tspan nb={988} duration={1.5} delay={0.5} />
						</tspan>
					</text>
					<motion.text
						fill="#2b2e34"
						data-name="logement réhab "
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="40"
						fontWeight="700"
						transform="translate(550.069 5147.435)"
						variants={textVariants}
						initial="hidden"
						animate={controls}
					>
						<tspan x="50" y="29">
							tonnes de CO2 évitées
						</tspan>
					</motion.text>
				</g>
			</svg>
		</SVGJSContainer>
	)
}

export default Promouvoir6
